import WeeklyRevenue from "views/admin/default/components/WeeklyRevenue";
import TotalSpent from "views/admin/default/components/TotalSpent";
import PieChartCard from "views/admin/default/components/PieChartCard";
import {MdOutlineSupportAgent, MdOutlineThumbsUpDown} from "react-icons/md";
import {GrProjects} from "react-icons/gr";
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';
import Widget from "components/widget/Widget";
import ChatLogs from "views/admin/default/components/LogsDatatable";
import React, {useEffect, useState} from "react";
import {APIURL} from "../../../variables/constants";
import axios from 'axios';
import {barChartOptionsWeeklyRevenue, lineChartOptionsTotalSpent} from "../../../variables/charts";
import {
    applyFilters,
    clearFilters,
    sumFunctionCalls,
    transformArrayToXY,
    transformDailyStats
} from "../../../variables/utils";
import {FaUserFriends} from "react-icons/fa";
import {PiChatsFill} from "react-icons/pi";
import {TbTargetArrow} from "react-icons/tb";
import {useSelector} from "react-redux";
import 'react-confirm-alert/src/react-confirm-alert.css';
import {Fab} from 'react-tiny-fab';
import 'react-tiny-fab/dist/styles.css';
import {addremovefilters, populateAllChats, populateAllNLP, populateChatUsage} from "../../../actions";
import {IoCloseSharp} from "react-icons/io5";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import FullscreenOverlay from "../../../components/overlays";
import {useLocation} from "react-router-dom";


const getDefaultYearRange = () => {
    const end = new Date();
    const start = new Date();
    start.setFullYear(end.getFullYear() - 1);

    return [start, end];
};

const Dashboard = () => {
    const [isOverlayOpen, setIsOverlayOpen] = useState(true);
    const [chatlogs, setChatLogs] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [usersCount, setUsersCount] = useState(0);
    const [transfertoHumanPerc, setTransfertoHumanPerc] = useState([]);
    const [accuracy, setAccuracy] = useState(0);
    const [avgrating, setAvgRating] = useState("N/A");
    const [rateCount, setRateCount] = useState(0);
    const [avgduration, setAvgduration] = useState(0);
    const [solvingStats, setSolvingStats] = useState([]);
    const [rawDailyStats, setRawDailyStats] = useState([]);
    const [dailyStats, setDailyStats] = useState([]);
    const [dailyStatsOptions, setDailyStatsOption] = useState(lineChartOptionsTotalSpent);
    const [mostFunctionsOptions, setMostFunctionsOptions] = useState(barChartOptionsWeeklyRevenue);
    const [mostFunctions, setMostFunctions] = useState([]);
    const [TransfersCategories, setTransfersCategories] = useState([]);
    const [topCategories, setTopCategories] = useState([]);

    let location = useLocation();

    let allfilters = useSelector(state => state.filters);
    let AllChats = useSelector(state => state.AllChats);
    let AllNLP = useSelector(state => state.AllNLP);
    let perday = useSelector(state => state.perday)

    const onDateChange = (daterange) => {
        clearFilters();
        // console.log("HERE", daterange);
        addremovefilters({filtername: "Date", value: daterange});
    }

    const getDateParams = () => {
        const dateFilter = allfilters.find(f => f.filtername === "Date");

        if (!dateFilter) return "";

        const [start, end] = dateFilter.value;

        const format = (d) => d.toISOString().split("T")[0];

        return `&fromdate=${format(start)}&todate=${format(end)}`;
    };


    const fetchData = async () => {
        try {
            const promises = [];

            if (!allfilters.some(f => f.filtername === "Date")) {
                const defaultRange = getDefaultYearRange();
                onDateChange(defaultRange);
                return;
            }

            const chatPromise = axios.get(`${APIURL}?query=all&platform=b2bchat${getDateParams()}`)
                .then(response => {
                    setChatLogs(response.data);
                    populateAllChats(response.data);
                });

            promises.push(chatPromise);

            const perdayPromise = axios.get(`${APIURL}?query=perday&platform=b2bchat${getDateParams()}`)
                .then(response => {
                    let all = response.data.sort((a, b) => new Date(a.Date) - new Date(b.Date));
                    setRawDailyStats(all);
                    populateAllNLP(all);
                });

            promises.push(perdayPromise);

            await Promise.all(promises);

            setIsOverlayOpen(false);

        } catch (err) {
            console.error(err);
        }
    };


    useEffect(() => {
        fetchData();
    }, [allfilters]);


    useEffect(() => {

        if (chatlogs.length > 0) {

            let transfertoHumanArr = [];
            let transfersCategoriesArr = [];
            let functionsArr = [];
            let categoriesArr = [];
            let all = chatlogs;

            all = applyFilters(all, allfilters);

            setTableData(all);

            let avg = all.map(a => a.rating).filter(n => n && n.toLowerCase() !== "n/a");
            let allfunctions = all.map(a => a.functions).filter(n => n);
            let allCorrectInfo = all.map(a => a.CorrectInfo).filter(n => n);

            let allcategories = all.map(a => a.Category).filter(n => n);
            // let transferrequestedNotDirectly = all.map(a => a.AgentRequestedDirectly).filter(n => n && n.toLowerCase() == 'no');

            let transfersYes = all.map(a => a.transfer_to_agent).filter(n => n && n.toLowerCase() == 'true');
            let transferredYes = ((transfersYes.length / all.length) * 100).toFixed(2);


            if(allfilters.some(item => item.filtername === 'transfer_to_agent')){
                transfersCategoriesArr = [];


                if(allfilters.some(item => item.filtername === 'transfer_to_agent' && item.value.toLowerCase() === "true")){
                    transfersCategoriesArr = [
                        {
                            "data": [
                                {
                                    "x": "User requests transfer directly",
                                    "y": all.filter(item => item.AgentRequestedDirectly.toLowerCase() === "yes" && item.transfer_to_agent.toLowerCase() === 'true').length
                                },
                                {
                                    "x": "Bot fails to solve, user asks for agent transfer",
                                    "y": all.filter(item => item.isTransferRequested.toLowerCase() === "true" && item.transfer_to_agent.toLowerCase() === 'true').length
                                },
                                {
                                    "x": "Bot suggests transfer",
                                    "y": all.filter(item => item.agentTransferSuggested.toLowerCase() === "true" && item.transfer_to_agent.toLowerCase() === 'true').length
                                }
                            ]
                        }
                    ]
                }

                if(allfilters.some(item => item.filtername === 'transfer_to_agent' && item.value.toLowerCase() === "false")){
                    transfersCategoriesArr = [
                        {
                            "data": [
                                {
                                    "x": "Bot suggested agent transfer, but user ended the conversation.",
                                    "y": all.filter(item => item.agentTransferSuggestedNoUserResponse.toLowerCase() === "true" && item.transfer_to_agent.toLowerCase() === 'false').length
                                },
                                {
                                    "x": "Bot solved queries",
                                    "y": all.filter(item => item.BotSolved.toLowerCase() === "true" && item.transfer_to_agent.toLowerCase() === 'false').length
                                },
                                {
                                    "x": "Bot wasn't able to solve queries",
                                    "y": all.filter(item => item.BotSolved.toLowerCase() === "false" && item.transfer_to_agent.toLowerCase() === 'false').length
                                }
                            ]
                        }
                    ]
                }

            }



            let durations = all.map(a => a.duration).filter(n => n > 0)

            let allsolvedStatus = all.map(a => a.BotSolved);
            let avgsum = avg.reduce((pv, cv) => parseInt(pv) + parseInt(cv), 0);
            let avgduration = durations.reduce((pv, cv) => parseInt(pv) + parseInt(cv), 0);
            let allaccurateinfo = allCorrectInfo.filter(n => n && n.toLowerCase() == 'yes');

            avgduration = (avgduration / 1000) / 60;

            let users = all.map(a => {
                return a.FileName ? a.FileName.split('_').pop() : null;
            });

            users = [...new Set(users.filter(u => u !== null))];

            setRateCount(avg);

            functionsArr = allfunctions
                .map(item => {
                    try {
                        if (typeof item === "string") {
                            const normalized = item.replace(/'/g, '"');
                            return JSON.parse(normalized);
                        }
                        return item;
                    } catch (e) {
                        console.warn("Skipping invalid functions JSON:", item);
                        return null;
                    }
                })
                .filter(Boolean);

            transfertoHumanArr.push(parseFloat(transferredYes));
            transfertoHumanArr.push(parseFloat(100 - transferredYes));

            functionsArr = sumFunctionCalls(functionsArr);

            // console.log("functions 2", functionsArr);

            categoriesArr = transformArrayToXY(allcategories);
            categoriesArr = [{data: categoriesArr}];

            setUsersCount(users.length);
            setAvgRating((avgsum / avg.length).toFixed(2));
            setAvgduration(((avgduration / durations.length)).toFixed(2));
            setAccuracy(((allaccurateinfo.length / allCorrectInfo.length)).toFixed(2) * 100);
            setTransfertoHumanPerc(transfertoHumanArr);
            setSolvingStats(allsolvedStatus);
            setTopCategories(categoriesArr);
            setMostFunctions(functionsArr);
            setTransfersCategories(transfersCategoriesArr);
        }


        if (rawDailyStats.length > 0) {
            const dateFilter = allfilters.find(item => item.filtername === "Date");
            if (!dateFilter) return;

            let selectedDates = dateFilter.value;
            let dates = rawDailyStats.map(a => a.Date);

            const startDate = new Date(selectedDates[0]);
            const endDate = new Date(selectedDates[1]);


            let alldata = rawDailyStats.filter(item => {
                const itemDate = new Date(item.Date);
                return itemDate >= startDate && itemDate <= endDate;
            });

            let result = transformDailyStats(alldata);
            setDailyStats(result.response);

            setDailyStatsOption((prevOptions) => ({
                ...prevOptions,
                xaxis: {
                    ...prevOptions.xaxis,
                    categories: dates,
                },
            }));
        }


    }, [chatlogs, allfilters, rawDailyStats])


    // function handlelogin() {
    //
    //     localStorage.setItem("username", document.getElementById("moderatorname").value);
    //     if (localStorage.getItem("username")) {
    //         return true;
    //     } else {
    //         return false;
    //     }
    // }

    const dateFilter = allfilters.find(item => item.filtername === "Date");

    return (
        <div>
            <FullscreenOverlay isOpen={isOverlayOpen}>
                <center>
                    <img src={"https://i.pinimg.com/originals/fc/71/63/fc71635c7f1b09ed30413f59bb749582.gif"}/>
                    <p>Your Dashboard is loading</p>
                    <p className={"opacity-50 italic"}>This may take up to 30 seconds..</p>
                </center>
            </FullscreenOverlay>
            {/* Card widget */}
            <div
                className="flex md:flex md:flex-grow flex-row justify-end space-x-1 mb-5 mt-5 grid grid-cols-1 gap-5 xl:grid-cols-4">
                <DateRangePicker clearIcon={null} onChange={onDateChange}
                                 value={dateFilter ? dateFilter.value : getDefaultYearRange()}
                />
            </div>


            <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
                <Widget
                    icon={<GrProjects className="h-7 w-7"/>}
                    title={"Projects Registered"}
                    subtitle={"1"}
                />
                <Widget
                    icon={<FaUserFriends className="h-6 w-6"/>}
                    title={"Total Users"}
                    subtitle={usersCount}
                />
                <Widget
                    icon={<PiChatsFill className="h-6 w-6"/>}
                    title={"Total Conversations"}
                    subtitle={chatlogs.length}
                />
                <Widget
                    icon={<MdOutlineThumbsUpDown className="h-7 w-7"/>}
                    title={"User Satisfaction Rating"}
                    subtitle={avgrating}
                    total={rateCount.length}
                />
                {/*<Widget*/}
                {/*    icon={<RxLapTimer className="h-6 w-6"/>}*/}
                {/*    title={"Average Conversation Duration (mins)"}*/}
                {/*    subtitle={avgduration}*/}
                {/*/>*/}
                <Widget
                    icon={<TbTargetArrow className="h-6 w-6"/>}
                    title={"Accuracy"}
                    subtitle={accuracy + "%"}
                />
                <Widget
                    icon={<MdOutlineSupportAgent className="h-7 w-7"/>}
                    title={"Transfers to Human Agent"}
                    subtitle={transfertoHumanPerc.length > 0 ? transfertoHumanPerc[1].toFixed(2) + "%" : "0%"}
                />

            </div>


            <div className="mt-5 grid grid-cols-1 gap-5 xl:grid-cols-2">
                <PieChartCard title={"Solved vs Unresolved"} type={1} pieChartData={solvingStats}/>
                <PieChartCard title={"Chats Transferred"} type={2} pieChartData={transfertoHumanPerc}/>
            </div>


            {allfilters.some(e => e.filtername === 'transfer_to_agent') && <div className="mt-5 grid grid-cols-1 gap-5">
                <WeeklyRevenue title={allfilters.some(e => e.filtername === 'transfer_to_agent' && e.value.toLowerCase() === "true") ? "Transfer Reasons":"Non-transfer reasons"} top={5} chartOptions={mostFunctionsOptions} tableData={TransfersCategories}/>
            </div>
            }


            <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
                <WeeklyRevenue title={"Top Functions Usage"} top={5} chartOptions={mostFunctionsOptions}
                               tableData={mostFunctions}/>
                <WeeklyRevenue title={"Top Chat Categories"} top={5} chartOptions={mostFunctionsOptions}
                               tableData={topCategories}/>
            </div>

            {/* Tables & Charts */}


            {/* Charts */}
            <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-1">
                <TotalSpent chartOptions={dailyStatsOptions} tableData={dailyStats}/>
            </div>


            <div className="grid grid-cols-1 gap-5 mt-5">
                <ChatLogs
                    viewMore={true}
                    tableData={tableData}
                />

            </div>


            {allfilters.length > 0 &&
                <Fab
                    mainButtonStyles={{backgroundColor: '#007bff'}}
                    position={{bottom: 24, right: 24}}
                    icon={<IoCloseSharp title={"Reset Filters"}/>}
                    event='click'
                    onClick={() => clearFilters(perday)}
                >

                </Fab>
            }

        </div>
    );
};

export default Dashboard;
